import i18n from 'i18next'
import { FC } from 'react'
import { CustomList } from '../../../../components/Display/Lists'
import {
  ApartmentConfirmation,
  ApartmentInformation
} from '../../../../types/apartments'
import { removeEmptyItems } from '../../../../utils/arrays'
import { getApartmentConfirmationForOverview } from '../../Forms/values/apartmentInitialValues'
import { getContractDetailsOrder } from '../utils/dataHandling'

interface ApartmentConfirmationListProps {
  apartmentConfirmation: ApartmentConfirmation
  apartmentInformation: ApartmentInformation
  t: i18n.TFunction
}

const ApartmentConfirmationList: FC<ApartmentConfirmationListProps> = ({
  apartmentConfirmation,
  apartmentInformation,
  t
}) => {
  const overviewData = getApartmentConfirmationForOverview(
    apartmentConfirmation,
    apartmentInformation
  )
  return (
    <CustomList
      t={t}
      translationPath='apartment.list.confirmation.'
      data={overviewData}
      informationOrder={removeEmptyItems(getContractDetailsOrder(overviewData))}
    />
  )
}

export default ApartmentConfirmationList
